import { useMemo } from "react";
import appConfig from "config/appConfig";
import { verifyPermission } from "helpers/permission";

export const useEndpoints = (plan, userPermissions) => {
  return useMemo(() => {
    const endPointConfig = {
      PRO: {
        list: `${appConfig.apiDomaine}/my/clients`,
        destroy: (accountId) =>
          `${appConfig.apiDomaine}/my/clients/${accountId}`,
      },
      MACRO: {
        holding: {
          list: `${appConfig.apiDomaine}/any/clients`,
          destroy: (accountId) =>
            `${appConfig.apiDomaine}/any/clients/${accountId}`,
        },
        filial: {
          list: `${appConfig.apiDomaine}/my/clients`,
          destroy: (accountId) =>
            `${appConfig.apiDomaine}/my/clients/${accountId}`,
        },
      },
    };

    let endPoint = {};

    if (plan === "MACRO") {
      if (
        verifyPermission(userPermissions, "list-client-from-any-institution") ||
        verifyPermission(userPermissions, "store-client-from-any-institution")
      ) {
        endPoint = endPointConfig[plan].holding;
      } else if (
        verifyPermission(userPermissions, "list-client-from-my-institution") ||
        verifyPermission(userPermissions, "store-client-from-my-institution")
      ) {
        endPoint = endPointConfig[plan].filial;
      }
    } else {
      endPoint = endPointConfig[plan];
    }

    return endPoint;
  }, [plan, userPermissions]);
};
